import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  candidateId: null,
};
export const personalDetailSlice = createSlice({
  name: 'personalDetails',
  initialState,
  reducers: {
    resetPersonalDetail: (state) => initialState,
    addCandidate: (state, action) => action.payload,
    setSearchable: (state, action) => ({ ...state, ...action.payload }),
  },
});

// Action creators are generated for each case reducer function
export const { resetPersonalDetail, addCandidate,setSearchable } = personalDetailSlice.actions;

export default personalDetailSlice.reducer;
